import { PassengerInputType } from "src/Modules/Flights/constants/JourneyDetails";

const getExtrasTotal = (data: PassengerInputType): number => {
  let total = 0;

  const addCategory = (items: Record<string, any> | undefined) => {
    Object.values(items ?? {}).forEach((val) => {
      if (!val || typeof val.price !== "number" || isNaN(val.price)) return;

      const quantity = val.quantity ?? 1;
      const itemTotal = val.price * quantity;

      if (!itemTotal || isNaN(itemTotal)) return;

      total += itemTotal;
    });
  };

  data.passengers?.forEach((passenger) => {
    passenger.segments?.forEach((segment) => {
      addCategory(segment.ssr?.baggages);

      segment.flights?.forEach((flight) => {
        addCategory(flight.ssr?.meals);
        addCategory(flight.ssr?.seats);
      });
    });
  });

  return total;
};

export { getExtrasTotal };
